export default "__VITE_ASSET__945782e8__"